import React, { useEffect, useState } from 'react'
import leftMenu from '../../Images/leftMenu.png'
import './Header.scss';
import { useLocation, useNavigate } from "react-router-dom";

export default function Header({ UserSession, setShowAllCompanies, setShowMenu, ZipCode, showMenu }) {
    const [userLogin, setuserLogin] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const [isMobile, setIsMobile] = useState(false)
    const url = new URL(window.location.href);
    //choose the screen size 
    const handleResize = () => {
        if (window.innerWidth < 700) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }
    useEffect(() => {
        if (window.innerWidth < 700) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
        window.addEventListener("resize", handleResize)
    }, []);

    return (
        <div className="Header" >
            <div className='Header1' >
                <a href="/" >HandyBy</a>
            </div>
            <div className="Header3">
                {!url.searchParams.get('spg') ?
                    <a href={UserSession && UserSession.FirstName ? '/account/projects' : '/my-projects'} >My Projects</a>
                    :
                    null
                }

                {url.pathname.includes('/pros/') && url.searchParams.get('spg') ?
                    <a className='start-project' onClick={()=>setShowAllCompanies(true)} >{isMobile && url.searchParams.get('spg') ? "Schedule Service" : !isMobile ? "Schedule Service" : isMobile ? "+" : ""}</a>
                    :
                    <a className='start-project' href={!url.searchParams.get('spg') ? '/start-project' : `/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${url.pathname.split('/')[2]}${url.search ? "&" + url.search.slice(1) : ""}`}  >{isMobile && url.searchParams.get('spg') ? "Start a Project" : !isMobile ? "Start a Project" : isMobile ? "+" : ""}</a>
                }
                {!url.searchParams.get('spg') ?
                    <div className="Header3Box" onClick={() => { setuserLogin(true) }}>
                        {showMenu ?
                            <img src={leftMenu} alt="" onClick={() => setShowMenu(true)} />
                            :
                            <img src={leftMenu} alt="" onClick={() => setShowMenu(true)} />
                        }
                    </div>
                    : null}
            </div>
        </div>
    )
}
